import { graphql } from "relay-runtime"

export const chDeleteProgressNoteMutation = graphql`
  mutation chDeleteProgressNoteMutation($input: Ch_deleteProgressNoteInput!, $connections: [ID!]!) {
    deleteProgressNote: ch_deleteProgressNote(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      progressNote: ch_ProgressNote {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
